import React, { useState } from "react";

import { ObjectSchema, ValidationError } from "yup";
import useEffectOnce from "~/hooks/useEffectOnce";
import errorTracker from "~/utils/errorTracker";

export const ValidateOptions = ({
  sdk,
  schema,
  options,
  children,
}: {
  sdk: string;
  schema: ObjectSchema<object>;
  options: object;
  children: React.ReactNode;
}) => {
  const [validated, setValidated] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  useEffectOnce(() => {
    const validate = async () => {
      try {
        errorTracker.addBreadCrumb(
          "ValidateOptions",
          "Validating state options",
          {
            options,
          },
        );
        await schema.validate(options, { abortEarly: false });
        setValidated(true);
      } catch (error) {
        const validationError = error as ValidationError;
        setValidationErrors(validationError.errors);

        errorTracker.addBreadCrumb(
          "ValidateOptions",
          "State option validation failed",
          {
            errors: validationError.errors,
          },
        );
      }
    };

    if (!validated) {
      validate();
    }
  });

  if (!validated) {
    if (validationErrors.length) {
      const error = `Could not load ${sdk}`;

      console.error(`${error}: ${validationErrors.join(", ")}`);
      return <p data-testid="error-message">{error}</p>;
    }

    return <></>;
  }

  return children;
};
